module.exports = __webpack_public_path__ + "static/communication-img-7f989c3aed9e801df948fb790ea4b914.png";